<template>
    <!-- 此为顶部菜单，不写业务 -->
    <div id="course-management-public">
        <AppBarOperation class="tab-area" @clicked="comp_show"/>
        <transition name="fade" mode="out-in">
            <div key="1" v-if="operationLogCompnent_Show">
                <operationLogCompnent @openFlag="openFlagListener"></operationLogCompnent>
            </div>
            <div key="2" v-if="loginLogCompnent_Show">
                <loginLogCompnent @openFlag="openFlagListener"></loginLogCompnent>
            </div>
        </transition>
    </div>
</template>

<script>
    import operationLogCompnent from "@/views/business/operation-log-management";
    import loginLogCompnent from "@/views/business/login-log-management";
    import AppBarOperation from "@/components2/AppBar-operation"

    export default {
        components: {
            operationLogCompnent,
            loginLogCompnent,
            AppBarOperation,
        },
        data() {
            return {
                operationLogCompnent_Show: true,
                loginLogCompnent_Show: false,
                id: '',
                editflg: '',
                roleName: '',
                navi: [
                    {name: "operation-log-public"},
                ],
            };
        },
        beforeMount() {

            this.$store.commit('SET_NAVI_DATA', this.navi);
        },
        created() {
            if (sessionStorage.getItem("store")) {
                this.$store.replaceState(
                    Object.assign(
                        {},
                        this.$store.state,
                        JSON.parse(sessionStorage.getItem("store"))
                    )
                );
                sessionStorage.removeItem("store");
            }
            window.addEventListener("beforeunload", () => {
                sessionStorage.setItem("store", JSON.stringify(this.$store.state));
            });
        },
        //页面载入之前
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                const params = {
                    flag: vm.$route.params.flag,
                };
                if (
                    params.flag != undefined &&
                    params.flag != null &&
                    params.flag != ""
                ) {
                    // 判断返回某个菜单
                    vm.comp_show(params.flag);
                }
            });
        },
        methods: {
            openFlagListener(val) {
                if (val.id !== '' && val.id !== null && val.id !== undefined) {
                    this.id = val.id
                }
                if (val.editflg !== '' && val.editflg !== null && val.editflg !== undefined) {
                    this.editflg = val.editflg
                }
                if (val.name !== '' && val.name !== null && val.name !== undefined) {
                    this.roleName = val.name
                }
                if (val.flag !== '') {
                    this.comp_show(val.flag)
                }

            },
            comp_show(flag) {
                this.operationLogCompnent_Show = false;
                this.loginLogCompnent_Show = false;
                if (flag == 1) {
                    this.operationLogCompnent_Show = true;
                } else if (flag == 2) {
                    this.loginLogCompnent_Show = true;
                } 
            },
        },
    };
</script>

<style lang="scss" scoped>
    .tab-area {
        margin-top: 0.5em;
        padding: 0 2em;
    }

    .fade-enter-active,
    .fade-leave-active {
        /*left: 0;*/
        transition: all .2s;
    }

    .fade-enter,
    .fade-leave-to {
        /*left: 20%;*/
        opacity: 0;
    }

    div {
        position: relative;
    }
</style>